import { useState } from 'react';

export const useShowQuestionsVideo = () => {
  const [showVideo, setShowVideo] = useState(false);
  const hidePreviewPicture = () => setShowVideo(true);

  return { showVideo, hidePreviewPicture };
};

